import { render, staticRenderFns } from "./PartnerPortalLayout.vue?vue&type=template&id=2d3421e8&scoped=true&"
import script from "./PartnerPortalLayout.vue?vue&type=script&lang=js&"
export * from "./PartnerPortalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPortalLayout.vue?vue&type=style&index=0&id=2d3421e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3421e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
